/**
 * MIT License
 *
 * Copyright (c) 2023 Jamasp Team
 * <mailto:radmanesh@gmail.com Arman Radmanesh>
 * <mailto:salarirad@gmail.com Mostafa Salari Rad>
 */
import { useEffect } from 'react';
import PropTypes from 'prop-types';

export default function ProjectCard({ project, handleDeleteProject, handleProjectAction }) {

  useEffect(() => {
    console.log('ProjectCard mounted');
    return () => console.log('ProjectCard unmounted');
  }, []);

  const participantCount = project?.registeredParticipants?.length || 0;

  return (
    <div className="ja-project-card">
      <div
        style={{ flex: 1, minWidth: 0 }}
        onClick={() => handleProjectAction({ action: 'show', data: project.id })}
      >
        <div className="ja-project-card-name">{project.name}</div>
        <div className="ja-project-card-sub">
          {participantCount} participant{participantCount !== 1 ? 's' : ''} &middot; id: {project.id}
        </div>
      </div>

      <div className="ja-project-card-actions">
        <button
          className="ja-btn ja-btn-ghost"
          title="View participants"
          onClick={() => handleProjectAction({ action: 'participants', data: project.id })}
        >
          Participants
        </button>
        <button
          className="ja-btn ja-btn-outline"
          title="View project"
          onClick={() => handleProjectAction({ action: 'show', data: project.id })}
        >
          Open
        </button>
        <button
          className="ja-btn ja-btn-danger"
          title="Delete project"
          onClick={() => handleDeleteProject(project.id)}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

ProjectCard.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    registeredParticipants: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  handleDeleteProject: PropTypes.func.isRequired,
  handleProjectAction: PropTypes.func.isRequired,
};
